<template>
  <el-dialog :body-padding="false" :width="width" :height="height" :append-to-body="true" :stopPropagation="false"
             :visible="visible" :title="title" :close-on-press-escape="false"  @closed="handleClosed" @opened="handleOpened">
    <x-page-container class="common-page-container common-dialog-content">
      <template v-slot:main>
        <div class="main-scroll-bar">
          <x-condition ref="xCondition" :condition-config="conditionConfig"></x-condition>
        </div>
      </template>
      <template v-slot:footer>
        <x-button-group :button-config="buttonConfig"></x-button-group>
      </template>
    </x-page-container>
  </el-dialog>
</template>

<script>
import {FIELD_TYPE_TEXTAREA} from "@/util/x-condition-constant";
import {handleError} from "@/util/componentUtil";

export default {
  name: 'prompt-dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '500px'
    },
    height: {
      type: String,
      default: '260px'
    },
    title: {
      type: String,
      default: '提示'
    },
    confirm: Function,
    cancel: Function,
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    },
    confirmButtonText: {
      type: String,
      default: '确定'
    },
    maxlength: {
      type: Number,
      default: 100
    },
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      buttonConfig: {
        align: 'right',
        list: [
          {
            name: this.cancelButtonText,
            plain: true,
            type: 'default',
            click: () => {
              if (this.cancel) {
                this.cancel({dialog: this});
                return;
              }
              this.close();
            }
          },
          {
            name: this.confirmButtonText,
            click: async () => {
              try {
                await this.$refs.xCondition.validate();
                if (this.confirm) {
                  this.confirm({value: this.conditionConfig.model.value, dialog: this});
                  return;
                }
                this.close();
              } catch (error) {
                handleError(error)
              }
            }
          }
        ]
      },
      conditionConfig: {
        labelPosition: 'top',
        labelWidth: '116px',
        model: {
        },
        rules: {
          value: [{required: this.required, message: '请输入' + this.label, trigger: 'blur'}],
        },
        list: [
          {
            field: 'value',
            label: this.label,
            type: FIELD_TYPE_TEXTAREA,
            maxlength: this.maxlength,
            rows: 6,
            span: 24
          }
        ]
      },
    };
  },
  methods: {
    close() {
      this.$emit('update:visible', true);
    },
    handleOpened(e) {
      this.$emit('opened', e);
    },
    handleClosed() {
      this.$emit('update:visible', false);
    },
    validate() {
      return this.$refs.xCondition.validate();
    }
  }
}
</script>

<style lang="scss">
</style>